import 'javascripts/jquery-ui/dialog-effect-clip'
import { jqUrlUtils, closeModal } from 'javascripts/general_scripts'

jqUrlUtils(); closeModal();

// For linking account modal window
$('.gitb-modal-authenticate-open').click(function() {
  let params = {};
  $.each($(this).data(), (k,v) => params[k] = v);
  if (!$.isEmptyObject(params)) {
    let modalLiBtn = $('#modal-linkedin-button');
    modalLiBtn.attr('href', $.addSearchParams(modalLiBtn.attr('href'), params))
  }

  window.modalWindow = $('#verify-account.itcs-modal').dialog({
    dialogClass: "gitb-register-modal",
    height: "auto",
    width: 600,
    modal: true,
    show: {effect: 'clip', speed: 'fast'},
    resizable: false,
    draggable: false,
    closeText: 'hide',
    open() {
      $('.ui-widget-overlay').on('click', () => window.modalWindow.dialog('close'));
    }
  });
  return false;
});